import Vue from 'vue'
import Router from 'vue-router'
import Register from '../views/Register'
import Login from '../views/Login'
import SamlSuccess from '../views/SamlSuccess'
import Servers from '../views/Servers'
import Environments from '../views/Environments'
import Tasks from '../views/Tasks'
import TasksEdit from '../views/TasksEdit'
import TasksAdd from '../views/TasksAdd'
import TasksHistory from '../views/TasksHistory'
import Jobs from '../views/Jobs'
import JobsDetails from '../views/JobsDetails'
import JobsSchedule from '../views/JobsSchedule'
import JobsHistory from '../views/JobsHistory'
import Administration from '../views/Administration'
import ResetPassword from '../views/ResetPassword'
import Agents from '../views/Agents'
import store from '../store/store'
import AllTaskHistory from '../views/AllTaskHistory'
import AllJobHistory from '../views/AllJobHistory'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: store.state.instanceId ? `/servers/${store.state.instanceId}/tasks` : 'servers',
    },
    {
      path: '/servers/:instanceId/tasks',
      name: 'tasks',
      component: Tasks,
    },
    {
      path: '/servers/:instanceId/tasks/edit',
      name: 'tasksedit',
      component: TasksEdit,
    },
    {
      path: '/servers/:instanceId/tasks/add',
      name: 'tasksadd',
      component: TasksAdd,
    },
    {
      path: '/servers/:instanceId/tasks/history',
      name: 'taskshistory',
      component: TasksHistory,
    },
    {
      path: '/servers/:instanceId/task/all-history',
      name: 'allhistory',
      component: AllTaskHistory,
    },
    {
      path: '/servers/:instanceId/packages',
      name: 'packages',
      component: Jobs,
    },
    {
      path: '/servers/:instanceId/packages/history',
      name: 'packageshistory',
      component: JobsHistory,
    },
    {
      path: '/servers/:instanceId/packages/all-history',
      name: 'packageAllHistory',
      component: AllJobHistory,
    },
    {
      path: '/servers/:instanceId/packages/schedule',
      name: 'packagesschedule',
      component: JobsSchedule,
    },
    {
      path: '/servers/:instanceId/packages/details',
      name: 'packagesdetails',
      component: JobsDetails,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/saml/success',
      name: 'saml',
      component: SamlSuccess,
    },
    {
      path: '/password',
      name: 'password',
      component: ResetPassword,
    },
    {
      path: '/servers',
      name: 'servers',
      component: Servers,
    },
    {
      path: '/environments',
      name: 'environments',
      component: Environments,
      props: true,
    },
    {
      path: '/administration',
      name: 'administration',
      component: Administration,
    },
    {
      path: '/agents',
      name: 'agents',
      component: Agents,
    },
  ],
})
